<template>
  <div
    class="gw_layout"
    :style="focusMode ? '--vh-3 :100vh' : ''"
  >
    <AppBar
      v-if="!mobile"
      :focusMode="focusMode"
    />

    <!-- <slot name="before" /> -->

    <main class="gw_layout_content">
      <slot />
    </main>

    <div
      v-if="!mobile && focusMode"
      class="anim-fade-in focus-mode_opener text-medium gw_btn gw_btn_text"
      style="
        --clr: var(--clr-black-4);
        --clr-hover: var(--clr-primary);
        --clr-hover-white: rgba(255, 255, 255, 0.03);
      "
      @click="$store.dispatch('globals_focus_mode')"
    >
      {{ $t('common.close_focusmode', { key: 'Esc' }) }}
    </div>

    <!-- rendering this here without a wrapper div stops playing iframe coaching-videos on resize !? wtf - maybe this is fixed in VUE3? -->
    <!-- https://forum.vuejs.org/t/possible-bug-strange-behavior-when-using-v-if-directives-before-and-after-iframe/74970 -->
    <!-- <AppFooter v-if="mobile" /> WILL RESULT IN VIDEO STOPPING and rerendering of iframe-->
    <div>
      <div v-if="mobile">
        <AppFooter />
      </div>
    </div>
  </div>
</template>

<script>
import AppBar from '@/components/AppBar/AppBar'
import AppFooter from '@/components/AppBar/AppFooter'

export default {
  name: 'LayoutAppBar',

  components: {
    AppBar,
    AppFooter,
  },

  computed: {
    focusMode() {
      return this.$store.getters.focus_mode
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>
<style lang="scss" scoped>
.focus-mode_opener {
  position: fixed;
  bottom: 1rem;
  // top: 1rem;
  right: 1rem;
  z-index: 8;
}
.gw_layout {
  position: fixed; // safari hack
  top: 0;
  left: 0;
  z-index: var(--z-index-layout-app-bar);
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100vw;
  height: var(--vh-100);
  min-height: 0;
  overflow: clip;
  &_content {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: var(--clr-black-0);
    // background: var(--clr-black-0-1);
    // background: var(--clr-black-0-2);
    // background: linear-gradient(
    //   88deg,
    //   var(--clr-black-0),
    //   var(--clr-black-0-4)
    // );

    transition: 0.2s;
    margin: auto;
    width: 100vw;
    max-width: 100vw;
    min-height: 0;
    overflow: clip;
    z-index: 1;
    // padding: 0 var(--safe-area-inset-left) 0 var(--safe-area-inset-left);
  }
  &:after {
    content: '';
    height: var(--safe-area-inset-bottom);
    width: 100%;
    bottom: 0;
    background: var(--clr-black-0);
    // background: red;
    position: fixed;
    z-index: 99;
  }
}

@media (max-width: 1023px) {
  .gw_layout {
    &_content {
      height: var(--vh-3);
      max-height: var(--vh-3);
    }
  }
}
</style>
